import React, { useState, useEffect, useCallback } from "react";
import { generateRandomPurchase } from "./purchasePopupData";
import "./PurchasePopup.css";

// Default image fallback
import defaultImg from "../../assets/images/dream-prize.jpeg";

const PurchasePopup = ({
  interval = 300000, // Default: 5 minutes (300000ms)
  displayDuration = 6000, // How long popup stays visible (6 seconds)
  initialDelay = 10000 // Show first popup after 10 seconds
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [purchaseData, setPurchaseData] = useState(null);
  const [imageError, setImageError] = useState(false);

  // Generate and show a new purchase notification
  const showPopup = useCallback(() => {
    const newPurchase = generateRandomPurchase();
    setPurchaseData(newPurchase);
    setImageError(false);
    setIsVisible(true);

    // Hide popup after displayDuration
    setTimeout(() => {
      setIsVisible(false);
    }, displayDuration);
  }, [displayDuration]);

  // Close popup manually
  const handleClose = () => {
    setIsVisible(false);
  };

  // Handle image load error
  const handleImageError = () => {
    setImageError(true);
  };

  useEffect(() => {
    // Show first popup after initialDelay
    const initialTimeout = setTimeout(() => {
      showPopup();
    }, initialDelay);

    // Then show popup at regular intervals
    const intervalId = setInterval(() => {
      showPopup();
    }, interval);

    // Cleanup on unmount
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(intervalId);
    };
  }, [interval, initialDelay, showPopup]);

  if (!purchaseData) return null;

  const { customer, item, timeAgo, isDraw } = purchaseData;

  return (
    <div className={`purchase-popup ${isVisible ? "show" : ""}`}>
      <button
        className="purchase-popup-close"
        onClick={handleClose}
        aria-label="Close notification"
      >
        ×
      </button>

      <img
        className="purchase-popup-image"
        src={imageError ? defaultImg : item.image}
        alt={item.name}
        onError={handleImageError}
      />

      <div className="purchase-popup-text">
        <span className="purchase-popup-message">
          <span className="customer-name">{customer}</span>
          <span className="action-text">
            {isDraw ? " entered " : " purchased "}
          </span>
          <span className="item-name">{item.name}</span>
          {isDraw ? (
            <span className="draw-badge">Draw</span>
          ) : (
            <span className="product-badge">Product</span>
          )}
        </span>
        <span className="purchase-popup-time">{timeAgo}</span>
      </div>
    </div>
  );
};

export default PurchasePopup;
